<script>
  import { stepStore } from '../stores.js';
  import { fade, draw } from 'svelte/transition';
  import { expoOut, sineIn } from 'svelte/easing';

  let arcInParams = {duration: 1200, easing: expoOut};
  let arcOutParams = {duration: 300, easing: sineIn};

  let step;
  const unsubscribe = stepStore.subscribe(value => {step = value;});
</script>

<div class="arrow-circle" class:complete="{ step > 9 }">
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 400 400">
    <style>
      .arc{
        fill: none;
        stroke: aquamarine;
        stroke-dasharray: 240;
        stroke-dashoffset: 0;
        stroke-linecap: round;
      }
      .arc-0 {stroke-width: 30px; stroke: var(--color-blue-light-4)}
      .arc-1 {stroke-width: 40px; stroke: var(--color-blue-light)}
      .arc-2 {stroke-width: 50px; stroke: var(--color-blue-dark)}
      .fix-segment-collapse {
        fill: transparent;
      }
    </style>
    <mask id="mask-1">
      <path fill="white" d="M235.1 32.8l-22 20.7c53.8 4.8 99.3 38.6 120.7 85.6l28.8 15.8 17.7-29.3c-27.9-67.5-92.6-116-169-120.4l23.8 27.6z"/>
    </mask>
    <mask id="mask-2">
      <path fill="white" d="M369.8 181.8l-26.5-14.5c2.4 10.5 3.7 21.5 3.7 32.8 0 42.9-18.4 81.5-47.8 108.4l-6.1 32.4 33.2 7.7c42-35.8 68.7-89.1 68.7-148.5 0-17.1-2.2-33.6-6.4-49.4l-18.8 31.1z"/>
    </mask>
    <mask id="mask-3">
      <path fill="white" d="M269.8 355.9l5.6-29.8c-22 13.3-47.8 20.9-75.4 20.9-26.3 0-51.1-7-72.5-19.2L94.9 332l2.9 34c29.7 18.4 64.7 29 102.2 29 38.7 0 74.8-11.3 105.2-30.9l-35.4-8.2z"/>
    </mask>
    <mask id="mask-4">
      <path fill="white" d="M73.3 314.6l30.1-3.8C72.6 283.8 53 244.1 53 200c0-10.1 1-20 3-29.5l-14-29.7-31.5 13.3C6.9 168.9 5 184.2 5 200c0 60.7 27.9 114.9 71.4 150.7l-3.1-36.1z"/>
    </mask>
    <mask id="mask-5">
      <path fill="white" d="M51.9 114.9l12.9 27.4c20.4-47.6 65.3-82.4 118.7-88.4l23.9-22.5L185 5.6C109 11.4 45 61 18.3 129.1l33.6-14.2z"/>
    </mask>
    <g id="circle">
      <g id="segment-1" mask="url(#mask-1)">
        <rect class="fix-segment-collapse" x="0" y="0" width="100%" height="100%"></rect>
                            <path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-0" d="M219.5 30.1c74 8.4 133.6 64 148.1 135.9"/>
        {#if step>=1}<path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-1" d="M219.5 30.1c74 8.4 133.6 64 148.1 135.9"/>{/if}
        {#if step>=6}<path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-2" d="M219.5 30.1c74 8.4 133.6 64 148.1 135.9"/>{/if}
      </g>
      <g id="segment-2" mask="url(#mask-2)">
        <rect class="fix-segment-collapse" x="0" y="0" width="100%" height="100%"></rect>
                            <path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-0" d="M367.6 166c2.2 11 3.4 22.3 3.4 34 0 63.9-35 119.6-86.9 148.9"/>
        {#if step>=2}<path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-1" d="M367.6 166c2.2 11 3.4 22.3 3.4 34 0 63.9-35 119.6-86.9 148.9"/>{/if}
        {#if step>=7}<path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-2" d="M367.6 166c2.2 11 3.4 22.3 3.4 34 0 63.9-35 119.6-86.9 148.9"/>{/if}
      </g>
      <g id="segment-3" mask="url(#mask-3)">
        <rect class="fix-segment-collapse" x="0" y="0" width="100%" height="100%"></rect>
                            <path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-0" d="M284.1 348.9C259.3 363 230.6 371 200 371c-44.6 0-85.2-17.1-115.7-45.1"/>
        {#if step>=3}<path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-1" d="M284.1 348.9C259.3 363 230.6 371 200 371c-44.6 0-85.2-17.1-115.7-45.1"/>{/if}
        {#if step>=8}<path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-2" d="M284.1 348.9C259.3 363 230.6 371 200 371c-44.6 0-85.2-17.1-115.7-45.1"/>{/if}
      </g>
      <g id="segment-4" mask="url(#mask-4)">
        <rect class="fix-segment-collapse" x="0" y="0" width="100%" height="100%"></rect>
                            <path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-0" d="M84.3,325.9C50.3,294.7,29,249.8,29,200c0-25.4,5.5-49.4,15.4-71.1"/>
        {#if step>=4}<path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-1" d="M84.3,325.9C50.3,294.7,29,249.8,29,200c0-25.4,5.5-49.4,15.4-71.1"/>{/if}
        {#if step>=9}<path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-2" d="M84.3,325.9C50.3,294.7,29,249.8,29,200c0-25.4,5.5-49.4,15.4-71.1"/>{/if}
      </g>
      <g id="segment-5" mask="url(#mask-5)">
        <rect class="fix-segment-collapse" x="0" y="0" width="100%" height="100%"></rect>
                             <path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-0" d="M44.4 128.9C71.4 70 130.9 29 200 29c6.6 0 13.1.4 19.5 1.1"/>
        {#if step>= 5}<path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-1" d="M44.4 128.9C71.4 70 130.9 29 200 29c6.6 0 13.1.4 19.5 1.1"/>{/if}
        {#if step>=10}<path in:draw="{arcInParams}" out:draw="{arcOutParams}" class="arc arc-2" d="M44.4 128.9C71.4 70 130.9 29 200 29c6.6 0 13.1.4 19.5 1.1"/>{/if}
      </g>
    </g>
  </svg>
</div>

<style>
  div {
    /* position: absolute; */
    pointer-events: none;
    /* width: 100%; */
    /* top: 50%; */
    /* left: 50%; */
    /* transform: translate(-50%, -50%); */
    transform: translate(0,0); /* needed for .sunburst-container alignment*/
    line-height: 0; /*make sure svg is centered vertically, critical for .complete animation */
  }

  div::before {
    content: '';
    display: block;
    position: absolute;
    /* background: radial-gradient(circle at 50% 50%, transparent 40%, #fbc202 60%, transparent 60%); */
    background: radial-gradient(circle at 50% 50%, transparent 60%, #fbc202 60%, #fbc202 70%, transparent 70%);
    width: 100%;
    height: 100%;
    z-index: -1;
    opacity: 0;
  }

  div.complete svg {
    /* 0.3s delay is critical to stop Joints from moving during rotation */
    transition: transform 0.6s 0.3s cubic-bezier(0.8, 0, 0.6, 1);
    transform: rotate(144deg); /* 1 segment = 72deg */
  }

  /* div.complete svg {
    animation: glow 0.5s 0.3s forwards cubic-bezier(0, 0, 0, 1);
  } */
  /* div.complete .arc-2 {
    animation: color-fade 0.8s forwards cubic-bezier(0, 0, 0, 1);
  } */

  div.complete::before {
    animation: ping 1.3s 0.6s forwards cubic-bezier(0, 0, 0, 1);
  }

  @keyframes ping {
      0% {transform: scale(1);   opacity:0;}
     10% {                       opacity:1;}
     30% {                       opacity:1;}
    100% {transform: scale(2);   opacity:0;}
  }

  /* @keyframes glow {
      0% { filter: none }
     10% { filter: saturate(10) hue-rotate(-170deg) brightness(1.8); }
     50% { filter: saturate(1) hue-rotate(-170deg) brightness(1); }
    100% { filter: none }
  } */
  /* @keyframes color-fade {
     10% { stroke: var(--color-blue-dark); }
     30% { stroke: var(--color-accent-yellow); }
    100% { stroke: var(--color-blue-dark); }
  } */
</style>
